export default "__VITE_ASSET__DXCz1$DM__"